import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import * as sendProjCol from '../../../../store/actions/sendProjCol';
import { connect } from 'react-redux';

const Tbody = (props) => {
    const { colaboradores, idProjeto, colaboradoresFiltrados, sendColaboratorsToStore } = props;

    const [localColaboradores, setLocalColaboradores] = useState([]);

    useEffect(() => {
        setLocalColaboradores(colaboradores);
    }, [colaboradores]);

    const changeColaboradores = (id_col, id_sub) => {
        let col = localColaboradores.find(e => e.id_recurso === id_col);

        col = { ...col };
        col.acao = (col.id_subprojeto && col.id_subprojeto === id_sub) ? 'Excluindo' : 'Adicionando';
        col.id_subprojeto = (col.id_subprojeto && col.id_subprojeto === id_sub) ? null : id_sub;
        col.status = !col.status;

        const updated = localColaboradores.map(c =>
            c.id_recurso === col.id_recurso ? col : c
        );
        setLocalColaboradores(updated);
        sendColaboratorsToStore(updated);
    };

    const togglePodeApontar = id_recurso => {
        setLocalColaboradores(prev => {
            const updated = prev.map(col => {
                if (col.id_recurso !== id_recurso) return col;
                const newValue = !col.podeApontar;      
                return {
                    ...col,
                    acao: newValue ? 'Adicionando' : 'Excluindo',
                    podeApontar: newValue,
                    podeApontarChanged: true
                };
            });
            sendColaboratorsToStore(updated);         
            return updated;                           
        });
    };


const toggleApontamentoEmMassa = () => {
    const allEnabled = localColaboradores.every(c => c.podeApontar);
    const newValue = !allEnabled;

    const updatedColabs = localColaboradores.map(col => {
        if (col.podeApontar === newValue) return col;

        return {
            ...col,
            podeApontar: newValue,
            acao: newValue ? 'Adicionando' : 'Excluindo',
            podeApontarChanged: true
        };
    });

    setLocalColaboradores(updatedColabs);
    sendColaboratorsToStore(updatedColabs);
};

    const allEnabled = localColaboradores.every(c => c.podeApontar);
    const buttonLabel = allEnabled
        ? "Desabilitar apontamento em massa"
        : "Habilitar apontamento em massa";

    return (
        <>
            <tbody className="text-center table-striped">
                {
                    colaboradoresFiltrados.map(e => {
                        const local = localColaboradores.find(c => c.id_recurso === e.id_recurso);
                        return (
                            <tr key={e.id_recurso}>
                                <td className="td-gerenciamento">{e.recurso}</td>
                                <td className="td-gerenciamento">
                                    <label className="switch switch-t">
                                        <input
                                            type="checkbox"
                                            className="icon-col"
                                            checked={local?.podeApontar}
                                            onChange={() => togglePodeApontar(e.id_recurso)} />
                                        <span
                                            className="slider round"
                                        />
                                    </label>
                                </td>
                                <td className="td-gerenciamento">
                                    {
                                        !e.especial ?
                                            <label htmlFor="" className="switch switch-t">
                                                <input
                                                    type="checkbox"
                                                    className="icon-col"
                                                    checked={local?.id_subprojeto === idProjeto}
                                                    onChange={() => []}
                                                    disabled={!local?.podeApontar}
                                                />
                                                <span 
                                                    className={`slider round ${!local?.podeApontar ? 'inactive-slider-round' : ''}`}
                                                    onClick={() => local?.podeApontar ? changeColaboradores(e.id_recurso, idProjeto) : null}
                                                />
                                            </label>
                                            :
                                            <label htmlFor="" className="switch switch-t">
                                                <input
                                                    type="checkbox"
                                                    className="icon-col"
                                                    checked={local?.especial}
                                                    onChange={() => []}
                                                    disabled={!local?.podeApontar}
                                                />
                                                <span className="slider round inactive-slider-round" style={{}} />
                                            </label>
                                    }
                                </td>
                            </tr>
                        )
                    })
                }
                <tr>
                    <td colSpan="1"></td>
                    <td className="text-center py-3">
                        <button
                            className="btn btn-light rounded-pill shadow-sm px-4 py-2"
                            onClick={toggleApontamentoEmMassa}
                        >
                            <i
                                className={`fa ${allEnabled ? 'fa-toggle-on' : 'fa-toggle-off'
                                    } me-3`}
                            />
                            {buttonLabel}
                        </button>
                    </td>
                </tr>
            </tbody>
        </>
    );
};

const mapStateToProps = state => ({
    colaboradores: state.colaboradores.colaboradores,
    colaboradoresFiltrados: state.colaboradores.colaboradoresFiltrados,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(sendProjCol, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Tbody);